module.exports = __webpack_public_path__ + "img/1F1E7-1F1F3.10ee0f2b.svg";